import logoOption3 from "@/assets/logo-option-3.png";
import logo3a from "@/assets/logo-3a.png";
import logo3b from "@/assets/logo-3b.png";
import logo3c from "@/assets/logo-3c.png";
import logo3d from "@/assets/logo-3d.png";
import logo3e from "@/assets/logo-3e.png";

const logos = [
  { id: "3", src: logoOption3, name: "Original 3", desc: "Mjuk typografi med pennaikon" },
  { id: "3A", src: logo3a, name: "Variant A", desc: "Varm olivgrön med guldbruna detaljer" },
  { id: "3B", src: logo3b, name: "Variant B", desc: "Med korsordsgrid-ikon" },
  { id: "3C", src: logo3c, name: "Variant C", desc: "Med gul penna som understryker" },
  { id: "3D", src: logo3d, name: "Variant D", desc: "Med dekorativa stjärnor" },
  { id: "3E", src: logo3e, name: "Variant E", desc: "Handskriven kalligrafi-stil" },
];

const LogoOptions = () => {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-display text-3xl text-primary text-center mb-2">Välj logotyp</h1>
        <p className="text-muted-foreground text-center mb-8">Klicka på den du gillar bäst och berätta för mig!</p>
        
        <div className="space-y-6">
          {logos.map((logo) => (
            <div 
              key={logo.id} 
              className="bg-card border border-border rounded-lg p-4 hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="flex items-center gap-4 mb-3">
                <span className="bg-primary text-primary-foreground w-8 h-8 rounded-full flex items-center justify-center font-bold">
                  {logo.id}
                </span>
                <div>
                  <h2 className="font-display text-lg text-foreground">{logo.name}</h2>
                  <p className="text-sm text-muted-foreground">{logo.desc}</p>
                </div>
              </div>
              <div className="bg-[#f5f3eb] rounded-md p-4">
                <img 
                  src={logo.src} 
                  alt={`Logotyp alternativ ${logo.id}: ${logo.name}`}
                  className="w-full h-auto max-h-32 object-contain"
                />
              </div>
            </div>
          ))}
        </div>
        
        <p className="text-center mt-8 text-muted-foreground">
          Skriv numret på den logotyp du vill använda i chatten!
        </p>
      </div>
    </div>
  );
};

export default LogoOptions;
